<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destination-google-chat']"
               [videos]="['notification-destinations']"></app-help-page>
